export default __webpack_public_path__ + "static/media/chat_attachment_2.e36834fe.svg";